@if (initiator === 'featuredModule') {
    <div
        data-crlat="precreated-betbuilder-add-to-betslip"
        class="add-betslip"
        [ngClass]="{ 'odds-selected': isHomeSLPButtonSelected(hashIdSignal()), 'add-betslip-lads': isLadbrokes }"
        (click)="accaBarClick()"
        [class.suspended]="isSuspendedSignal()">
        <span
            class="bet-slip betslip-text"
            data-crlat="precreated-betbuilder-bet-slip-stake"
            [textContent]="isHomeSLPButtonSelected(hashIdSignal()) ? addedToBetslip : addToBetslip"></span>
        <strong class="qb-single-receipt-odds betslip-text" [textContent]="atTheRate"></strong>
        <span class="stake-amt betslip-text" data-crlat="precreated-betbuilder-stake-amt" [textContent]="formattedPrice()"></span>
    </div>
} @else {
    <div
        data-crlat="preCreatedBetBuilderAddToBetSlip"
        class="odds"
        [ngClass]="{ 'odds-selected': isSelected() }"
        (click)="accaBarClick()"
        [class.suspended]="isSuspendedSignal()"
        [class.odds-lads]="isLadbrokes">
        <span class="odds-price" data-crlat="preCreatedBetBuilderOddsPrice" [textContent]="formattedPrice()"></span>
    </div>
}
